import { Link } from "@tanstack/react-router";

import { Button } from "../../components/ui/button";
import { DASHBOARDS_PATH } from "../../appRoutes";
import type { DashboardCatalogItem } from "./catalog";

export function DashboardPlaceholder(props: { entry: DashboardCatalogItem | null; slug: string }) {
  const label = props.entry?.label ?? props.slug;
  const description =
    props.entry?.description ??
    "This dashboard is not in the Operators catalog yet. Return home to browse available views.";

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col items-start gap-4 px-6 py-12 sm:px-8">
      {props.entry ? (
        <div
          className="h-1.5 w-16 rounded-full"
          style={{ background: props.entry.color }}
          aria-hidden
        />
      ) : null}
      <div className="space-y-2">
        <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">
          Coming soon
        </p>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{label}</h1>
        <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
      </div>
      <Button render={<Link to={DASHBOARDS_PATH} />} variant="outline">
        Back to Dashboards
      </Button>
    </div>
  );
}
